import { Button, Group, LoadingOverlay, Modal, Stack, TextInput, Title } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import React from "react";
import { useMutation, useQueryClient } from "react-query";
import BackendServiceV2 from "services/v2/BackendService";
import { Check, Plus, X } from "tabler-icons-react";

export function EntityMetadataCategoryCreate({entityClass}) {

    const queryClient = useQueryClient();

    const [isCategoryCreateOpen, categoryCreateVisibility] = useDisclosure(false);

    const form = useForm({
        initialValues: {
            slug: '',
            displayName: '',
            entityClass: entityClass
        },
    
        validate: {
            slug: (value) => (/^[a-z-]+$/.test(value) ? null : 'Caracteres inválidos'),
        },
    });

    const {mutate: createCategory, isLoading} = useMutation(values => {
        return BackendServiceV2.post('/entity/metadata/category', values);
    }, {
        onSuccess: () => {
            queryClient.invalidateQueries('entity-metadata-list');
            categoryCreateVisibility.close();
            showNotification({
                title: 'Categoria criada com sucesso!',
                message: '',
                autoClose: 5000,
                color: 'green',
                icon: <Check />
            });
        },
        onError: (error) => {
            showNotification({
                title: 'Um erro ocorreu',
                message: error?.response?.data?.message,
                autoClose: 5000,
                color: 'red',
                icon: <X />
            });
        }
    })

    return (<>
        <Modal
            opened={isCategoryCreateOpen}
            onClose={categoryCreateVisibility.close}
            title={
                <Group position="center" noWrap>
                    <Title order={2}>Criar categoria</Title>
                </Group>
            }
            size="lg"
        >
            <LoadingOverlay visible={isLoading} />

            <form onSubmit={form.onSubmit(values => {createCategory(values)})} style={{width: '100%'}}>
                <Stack>
                    <TextInput
                        required
                        label="Slug"
                        description="Apenas minúsculas e -"
                        {...form.getInputProps('slug')}
                    />

                    <TextInput
                        required
                        label="Nome de exibição"
                        description="Nome exibido na interface para os usuários"
                        {...form.getInputProps('displayName')}
                    />

                    <Button type="submit">Criar</Button>
                </Stack>
            </form>
        </Modal>

        <Button variant="subtle" leftIcon={<Plus />} onClick={categoryCreateVisibility.open}>Adicionar categoria</Button>
    </>)
}